module.exports = __webpack_public_path__ + "static/media/logo3.629a98ad.jpg";